// You can write your custom Javascript here
//jQuery(document).ready(function () {
  if(!jQuery('#main-content #col-main').hasClass('shell')) {
      jQuery('#main-content #col-main').addClass('shell')
  }
//});